"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _qs = require('qs'); var _qs2 = _interopRequireDefault(_qs);

var _upgrade = require('shared/enum/upgrade');

 const getCurrentURL = () => window.location.href; exports.getCurrentURL = getCurrentURL












 const buildSubscriptionSuccessURL = (
  orgKey,
  planTypes,
  actionType,
  cfg = {},
) => {
  const { origin, hash } = window.location
  const params = {
    sub_orgkey: orgKey,
    sub_plan: planTypes.join(','),
    sub_action: actionType,
  }
  if (cfg.source) params.sub_source = cfg.source
  const query = _qs2.default.stringify(params)

  return `${origin}?${query}${hash}`
}; exports.buildSubscriptionSuccessURL = buildSubscriptionSuccessURL

const subscriptionItemTypes = new Set(Object.values(_upgrade.SubscriptionItemType))

const parsePlanTypes = (planType) => {
  if (typeof planType !== 'string') return []

  return planType
    .split(',')
    .filter((type) =>
      subscriptionItemTypes.has(type ),
    )
}

 const parseSubscriptionSuccessURL = () => {
  const params = _qs2.default.parse(window.location.search.slice(1)) 
  const {
    sub_orgkey: orgKey,
    sub_plan: planType,
    sub_action: actionType,
    sub_source: source,
  } = params
  const planTypes = parsePlanTypes(planType)

  return orgKey && planTypes.length > 0 && actionType
    ? { orgKey, planTypes, actionType, source }
    : null
}; exports.parseSubscriptionSuccessURL = parseSubscriptionSuccessURL

 const clearQS = () =>
  history.pushState({}, '', window.location.origin + window.location.hash); exports.clearQS = clearQS
